module.exports = __webpack_public_path__ + "img/yellowstars.0ccd4051.png";